var React = require('react');

function UnderlineInline (props) {
    return React.createElement("svg",props,React.createElement("line",{"x1":"0.5","y1":"0.5","x2":"549.5","y2":"0.500048","stroke":"#ADADAD","strokeLinecap":"round"}));
}

UnderlineInline.defaultProps = {"width":"550","height":"1","viewBox":"0 0 550 1","fill":"none"};

module.exports = UnderlineInline;

UnderlineInline.default = UnderlineInline;
